import { pluck, tagged } from '@range.io/functional'

const DocxTemplate = tagged('DocxTemplate', {
    name: 'String',
    isCustomTemplate: 'Boolean',
})

DocxTemplate.defaultTemplateNames = docxTemplates => {
    const defaultReportTemplates = docxTemplates.filter(t => !t.isCustomTemplate)
    return pluck('name', defaultReportTemplates)
}

DocxTemplate.customTemplateNames = docxTemplates => {
    const customReportTemplates = docxTemplates.filter(t => t.isCustomTemplate)
    return pluck('name', customReportTemplates)
}

export default DocxTemplate
